import { useEffect, useState } from 'react';
import { getOnline, subscribeNetwork } from '../lib/network';

/** Reactive online/offline flag for the stale-price banner. */
export function useNetworkStatus(): boolean {
  const [online, setOnline] = useState<boolean>(getOnline());
  useEffect(() => subscribeNetwork(setOnline), []);
  return online;
}
